import { ColorTokens, Palette } from '../../../model/Palette'

export const defaultPalette = {
  divider: Palette.GOSHAWK_GREY,
  line: Palette.GOSHAWK_GREY,
  border: {
    default: ColorTokens.border100,
    focused: Palette.SMOKY_SLATE,
  },
  primary: {
    main: Palette.DEEP_SEA_BLUE,
    lighter: Palette.VIOLET_HEAVEN_ALPHA,
    light: Palette.VIOLET_HEAVEN,
    dark: Palette.WASH_ME,
  },
  secondary: {
    main: Palette.CORAL_REEF_GREEN,
    light: Palette.DEEP_SEA_BLUE,
  },
  button: {
    main: Palette.DEEP_SEA_BLUE,
    secondary: Palette.WASH_ME,
    dark: Palette.BLACK_OUT,
    alternate: Palette.WASH_ME,
  },
  error: {
    main: Palette.DANGER,
  },
  background: {
    default: Palette.WHITE,
    paper: Palette.WHITE,
    light: Palette.WASH_ME,
    dark: Palette.WASH_ME,
  },
  text: {
    primary: ColorTokens.secondary500,
    secondary: Palette.SMOKY_SLATE,
  },
  grey: {
    50: Palette.BRIGHT_GREY,
    100: Palette.BRIGHT_GREY_2,
    200: Palette.GOSHAWK_GREY_ALPHA_70,
    300: Palette.GOSHAWK_GREY_ALPHA_60,
    400: Palette.GOSHAWK_GREY_ALPHA_50,
    500: Palette.GOSHAWK_GREY_ALPHA_40,
    600: Palette.GOSHAWK_GREY,
    700: Palette.BLACK_OUT_ALPHA_50,
    800: Palette.BLACK_OUT_ALPHA_40,
    900: Palette.BLACK_OUT,
  },
  alternate: {
    primary: Palette.DEEP_SEA_BLUE,
    secondary: Palette.BRIGHT_GREY_2,
    alternate: `${Palette.DEEP_SEA_BLUE}33`,
    background: Palette.DEEP_SEA_BLUE,
    text: Palette.WASH_ME,
    dark: Palette.DEEP_SEA_BLUE,
    light: Palette.WASH_ME,
    lighter: Palette.WASH_ME,
  },
}
